import React from 'react';
import {FormInput} from 'react-form';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

const Text =  ( { append, field, prefix, suffix, intl, ...rest } ) => {
  return (
    field ?
      <FormInput field={field}>
        {( { setValue, getValue, setTouched } ) =>
          append ?
            <div className="input-group">
              {!!prefix && <span className="input-group-addon pointer">{prefix}</span> }
              <input
                {...rest}
                value={getValue() || ''}
                onChange={val => setValue( val.target.value )}
                onBlur={() => setTouched()}
                placeholder={rest.placeholder ? intl.formatMessage( { id: rest.placeholder } ) : ''}
              />
              {suffix && <span className="input-group-addon pointer">{suffix}</span> }
            </div> :
            <input
              {...rest}
              value={getValue() || ''}
              onChange={val => {
                setValue( val.target.value )
                if(rest.onChange) rest.onChange(val.target.value)
              }}
              onBlur={() => setTouched()}
              placeholder={rest.placeholder ? intl.formatMessage( { id: rest.placeholder } ) : ''}
            />
        }
      </FormInput>
      :
      append ?
        <div className="input-group">
          {prefix && <span className="input-group-addon pointer">{prefix}</span> }
          <input {...rest}
                 value={rest.value || ''}
                 onChange={(val => rest.onChange( val.target.value ))}
                 placeholder={rest.placeholder ? intl.formatMessage( { id: rest.placeholder } ) : ''}
          />
          {suffix && <span className="input-group-addon pointer">{suffix}</span>}
        </div> :
        <input {...rest}
               value={rest.value || ''}
               onChange={(val => rest.onChange( val.target.value ))}
               placeholder={rest.placeholder ? intl.formatMessage( { id: rest.placeholder } ) : ''}
        />
  )
}

module.exports = injectIntl( Text );



// WEBPACK FOOTER //
// ./components/FormElements/Text/index.js